import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=template&id=23482a52&scoped=true&"
import script from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23482a52",
  null
  
)

export default component.exports